<template>
  <label class="icon-box">
    <!-- <a-popover v-model:visible="popVisible" trigger="click" placement="bottom">
      <template #content>
        <div class="operate" @click="calcIsAppoint('help')">帮患者预约</div>
        <a-divider style="margin: 8px 0" />
        <div class="operate" @click="calcIsAppoint('pushLink')">推送预约链接</div>
      </template>
      <auth-img class="icon-img" src="@/assets/img/chat/appointment-register.png" alt="" />
      <div class="icon-label">复诊预约</div>
    </a-popover> -->
    <div @click="calcIsAppoint('help')">
      <auth-img class="icon-img" src="@/assets/img/chat/appointment-register.png" alt="" />
      <div class="icon-label">复诊预约</div>
    </div>
  </label>
  <!-- 发送预约链接 -->
  <a-modal
    title="复诊预约"
    width="370px"
    style="top: 229px"
    v-model:visible="appointModal"
    @ok="handleOk"
  >
    <div class="appointContainer">
      <p class="text">请核实要进行就诊预约的医生</p>
      <p class="text">
        就诊医生：
        <span class="dcName" v-if="isHaveDoctor">
          {{ dotorInfo.username }}
        </span>
      </p>
      <p class="search" v-if="!isHaveDoctor">
        <a-auto-complete
          style="width: 100%"
          v-model:value="searchValue"
          optionLabelProp="name"
          placeholder="请输入医生姓名"
          @select="onSelectOption"
          @search="onSearchDoctor"
        >
          <template #options>
            <a-select-option v-for="d in searchOptions" :value="d.name" :key="d">
              <div class="optionItem">
                <span class="label">
                  <span
                    class="name elip--multiple"
                    style="-webkit-line-clamp: 1"
                    v-html="calcKeyWord(d.name)"
                  ></span>
                  <span class="info">
                    <span>{{ titleArr[d.titleId] }}</span>
                    <a-divider type="vertical" />
                    <span>{{ d.departmentName }}</span>
                  </span>
                </span>
                <span class="hospitalName elip--multiple" style="-webkit-line-clamp: 1">
                  {{ d.hospitalName }}
                </span>
              </div>
            </a-select-option>
          </template>
        </a-auto-complete>
      </p>
    </div>
  </a-modal>
  <!-- 帮患者预约 -->
  <a-drawer
    title="复诊预约"
    placement="right"
    :closable="true"
    :maskClosable="false"
    :visible="helpVisible"
    @close="handleClose"
    width="600"
  >
    <HelpAppoint v-if="helpVisible" @onclose="handleClose" @onAppointCb="callBackforAppoint" />
  </a-drawer>
  <AppointSetting ref="appointSetRef" />
</template>

<script setup>
import { ref, computed, defineProps, createVNode } from 'vue'
import { useStore } from 'vuex'
import { selectByDoctorName, appointDoctor } from '@/api/chat'
import { checkReserveFlag } from '@/api/workPlace/appoint'
import { message, Modal } from 'ant-design-vue'
import HelpAppoint from './helpAppoint.vue'
import AppointSetting from '../rightInfo/components/AppointSetting'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { callOut } from '@/utils/Tccc'

const appointModal = ref(false)
const searchValue = ref('')
const searchOptions = ref([])
const queryOption = ref({})
const titleArr = ref(['医师', '主治医师', '副主任医师', '主任医师'])
const props = defineProps({
  groupId: {
    type: String,
    default: ''
  }
})

const handleClose = () => {
  helpVisible.value = false
}

const onSearchDoctor = async e => {
  if (!e) return []
  const result = await selectByDoctorName(e)
  searchOptions.value = result
}
const onSelectOption = (val, options) => {
  searchValue.value = options.key.name
  queryOption.value = options.key
}

const calcKeyWord = val => {
  var Reg = new RegExp(searchValue.value, 'i')
  if (val) {
    return val.replace(Reg, `<span style="color: #1890FF;">${searchValue.value}</span>`)
  }
}

const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const userId = computed(() => store.getters.userId)
const dotorInfo = curOrder.value.doctorInfo
const isHaveDoctor = Object.keys(dotorInfo).length

const handleOk = () => {
  if (!isHaveDoctor && !searchValue.value) {
    message.warning('请选择预约医生')
    return
  }
  appointDoctor({
    ucDoctorId: isHaveDoctor ? dotorInfo.ucUserId : queryOption.value.id,
    ucPatientId: curOrder.value.patientInfo.ucUserId,
    ucDoctorAssistantId: userId.value,
    groupId: props.groupId
  })
    .then(() => {
      message.success('预约成功！')
    })
    .catch(() => {
      message.error('预约失败！')
    })
    .finally(() => {
      appointModal.value = false
    })
}
const calcIsAppoint = type => {
  checkReserveFlag({ doctorId: dotorInfo.businessId }).then(res => {
    if (res) {
      if (type === 'help') {
        helpAppointForPatient()
      } else {
        appointPush()
      }
    } else {
      popVisible.value = false
      showAppointSetting()
    }
  })
}
// 推送预约链接
const popVisible = ref(false)
const appointPush = () => {
  appointModal.value = true
  popVisible.value = false
}
// 帮患者预约
const helpVisible = ref(false)
const helpAppointForPatient = () => {
  helpVisible.value = true
  popVisible.value = false
}

const callBackforAppoint = () => {
  helpVisible.value = false
  showAppointSetting()
}

const appointSetRef = ref()
const showAppointSetting = () => {
  Modal.confirm({
    centered: true,
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: `医生未开通复诊预约通道，电联${dotorInfo.username}医生开通复诊预约，方便患者复诊。`,
    okText: '拨打',
    cancelText: '帮医生修改',
    onOk: () => {
      call()
    },
    onCancel() {
      appointSetRef.value.settingInit()
    }
  })
}

const call = () => {
  Modal.confirm({
    centered: true,
    title: '确定拨打电话',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定给医生-${dotorInfo.username}拨打电话吗？`,
    okText: '拨打',
    cancelText: '取消',
    onOk: () => {
      const params = {
        calleeType: 2,
        calleeUcUserId: dotorInfo.ucUserId,
        doctorId: dotorInfo.businessId,
        workOrderIds: []
      }
      callOut(params, {
        userType: '医生',
        name: dotorInfo.username
      })
    }
  })
}
</script>

<style lang="scss" scoped>
@import '../../index.scss';
.operate {
  cursor: pointer;
}

.appointContainer {
  min-height: 133px;
  .text {
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-bottom: 16px;

    .dcName {
      color: #999999;
    }
  }
}
.optionItem {
  height: 50px;
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
  color: #999999;
  .label {
    display: flex;
    justify-content: space-between;
    .name {
      width: 120px;
    }
  }
  .hospitalName {
    float: right;
    text-align: right;
    max-width: 220px;
  }
}
</style>
